import { jsPDF } from "jspdf";

export default function generateLunchReport(data, selectedDate = null) {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  // Use the selected date if provided, otherwise try to extract from data, otherwise use current date
  let formattedDate;
  if (selectedDate) {
    formattedDate = selectedDate;
  } else {
    let latestReportDate = null;
    data.forEach(helicopter => {
      if (helicopter.reportDate) {
        const currentDate = new Date(helicopter.reportDate);
        if (!latestReportDate || currentDate > latestReportDate) {
          latestReportDate = currentDate;
        }
      }
    });
    formattedDate = latestReportDate ? latestReportDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  }


  let yPos = 10; // Set initial Y position
  const blueColor = '#596787';
  const redColor = '#f04e26';
  const blackColor = '#000000';

  // Column definitions for consistent layout (defined early to avoid hoisting issues)
  // Optimized widths: reduced Diet Restr and Severity, increased Cannot Eat
  const columns = [
    { header: "Last Name", width: 40, key: 'lastName' },
    { header: "First Name", width: 40, key: 'firstName' },
    { header: "Diet Restr", width: 25, key: 'dietaryRestrictions' },
    { header: "Cannot Eat", width: 140, key: 'cannotEat' },
    { header: "Severity", width: 35, key: 'severity' },
  ];

  // Function to wrap text within a column width (defined early to avoid hoisting issues)
  const wrapText = (doc, text, maxWidth) => {
    if (!text) return [''];

    const words = text.toString().split(' ');
    const lines = [];
    let currentLine = '';

    words.forEach(word => {
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      const textWidth = doc.getTextWidth(testLine);

      if (textWidth <= maxWidth - 4) { // Leave 4 units padding
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          // Single word is too long, truncate it
          lines.push(word.substring(0, Math.floor(word.length * maxWidth / textWidth)));
        }
      }
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.length > 0 ? lines : [''];
  };

  // Function to draw text in a cell with proper boundaries (defined early to avoid hoisting issues)
  const drawCellText = (doc, text, x, y, width, height) => {
    const lines = wrapText(doc, text, width);
    const lineHeight = 3;

    // Draw each line of text
    lines.forEach((line, index) => {
      if (index * lineHeight < height - 1.5) { // Make sure text fits in cell height
        doc.text(line, x + 2, y + 3 + (index * lineHeight));
      }
    });

    return lines.length * lineHeight;
  };

  doc.setFontSize(18);
  doc.setTextColor(blackColor); // Set title color to black for readability
  doc.text("Group Lunch Report", 148, yPos, { align: "center" });
  yPos += 10; // Adjust position after the title

//Adding a cover page 
const addCoverPage = (doc)  => {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text(`Eagle Pass Heli`, 10, yPos);
  doc.text(`Date: ${formattedDate}`, 250, yPos);

  yPos += 20; // Adjust position after the Eagle Pass Heli and Date


  // Drawing the headers for main page table
  doc.setTextColor(blackColor);
  doc.setFontSize(14);
  doc.text(`Client with Dietary Restrictions`, 10, yPos);
  let y = 45;  
//build table here using the same column system
const drawMainHeaders = (doc, y) => {
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  doc.setFont('helvetica','bold');

  let x = 10;
  columns.forEach(col => {
    doc.setDrawColor(0);
    doc.setFillColor(211, 211, 211);
    doc.rect(x, y, col.width, 10, 'FD');
    doc.text(col.header, x + 5, y + 7);
    x += col.width;
  });
  doc.setFont('helvetica','normal');
  return y + 10;
};

  y = drawMainHeaders(doc, y);
  y += 5;
  doc.setFontSize(10);

  // Filter and render clients with dietary restrictions using the same column system
  data.forEach(helicopter => {
    helicopter.groups.forEach(group => {
      group.clients.forEach(client => {
        if (client.dietaryRestrictions) {
          // Calculate the row height needed based on text wrapping
          let maxRowHeight = 10; // Minimum row height

          // First pass: calculate required height for this row
          columns.forEach(col => {
            let cellText = '';
            if (col.key === 'lastName') {
              cellText = client.lastName || 'N/A';
            } else if (col.key === 'firstName') {
              cellText = client.firstName || 'N/A';
            } else if (col.key === 'dietaryRestrictions') {
              cellText = 'Yes';
            } else if (col.key === 'cannotEat') {
              cellText = client.cannotEat || 'N/A';
            } else if (col.key === 'severity') {
              cellText = client.severity || 'N/A';
            }

            const lines = wrapText(doc, cellText, col.width);
            const requiredHeight = Math.max(10, lines.length * 4 + 2);
            maxRowHeight = Math.max(maxRowHeight, requiredHeight);
          });

          // Draw cell borders and content
          let x = 10;
          columns.forEach(col => {
            // Draw cell border
            doc.setDrawColor(0);
            doc.setFillColor(255, 255, 255);
            doc.rect(x, y, col.width, maxRowHeight, 'FD');

            // Get cell content and set appropriate color
            let cellText = '';
            let textColor = redColor; // Default to red for dietary restriction clients

            if (col.key === 'lastName') {
              cellText = client.lastName || 'N/A';
            } else if (col.key === 'firstName') {
              cellText = client.firstName || 'N/A';
            } else if (col.key === 'dietaryRestrictions') {
              cellText = 'Yes';
            } else if (col.key === 'cannotEat') {
              cellText = client.cannotEat || 'N/A';
            } else if (col.key === 'severity') {
              cellText = client.severity || 'N/A';
            }

            // Set text color
            doc.setTextColor(textColor);

            // Draw cell content
            drawCellText(doc, cellText, x, y, col.width, maxRowHeight);

            x += col.width;
          });

          y += maxRowHeight;
        }
      })
    })
  });


  doc.addPage(); // Add a new page for the detailed reports
};


  
  // Removed checkPageOverflow - using inline page break logic
  // Pass this data to the cover page function
  addCoverPage(doc);

  yPos = 10;

  // Column definitions moved to top of file to avoid hoisting issues

  // Utility functions moved to top of file to avoid hoisting issues

  // Function to draw table headers
  const drawHeaders = (doc, y) => {
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');

    let x = 10;
    columns.forEach(col => {
      doc.setDrawColor(0);
      doc.setFillColor(211, 211, 211);
      doc.rect(x, y, col.width, 5, 'FD');
      doc.setTextColor(0, 0, 0);
      doc.text(col.header, x + 2, y + 3.5);
      x += col.width;
    });

    doc.setFont('helvetica', 'normal');
    return y + 5;
  };

  // Function to draw page header
  const drawPageHeader = (doc, helicopter, group, formattedDate) => {
    doc.setFontSize(10);
    doc.setTextColor(blackColor);
    doc.text(`Heli #${helicopter.heliIndex} - Group #${group.groupIndex} (H${helicopter.heliIndex}G${group.groupIndex})`, 10, 10);
    doc.text(`Date: ${formattedDate}`, 250, 10);
    doc.setTextColor(0, 0, 0);
    return 15; // Return Y position after header
  };

  // Remove the old header function - using the new one defined above

  let groupCount = 0;
  // Start processing each helicopter and its groups
  data.forEach(helicopter => {
    if (helicopter.heliIndex > 1) {
      doc.addPage('landscape');
      yPos = 10;
      groupCount = 0;
    }
    helicopter.groups.forEach(group => {
      if (groupCount > 0 && groupCount % 4 === 0) {
        doc.addPage('landscape');
        yPos = drawPageHeader(doc, helicopter, group, formattedDate);
        yPos = drawHeaders(doc, yPos);
        yPos += 2;
        groupCount = 0;
      }
      groupCount++;

      // Check if we need space for group header + table header (about 25 units)
      if (yPos + 25 > 180) {
        doc.addPage('landscape');
        yPos = drawPageHeader(doc, helicopter, group, formattedDate);
        yPos = drawHeaders(doc, yPos);
        yPos += 2;
      } else {
        // Only draw group header (not full page header) if we're not on a new page
        doc.setFontSize(10);
        doc.setTextColor(blackColor);
        doc.text(`Heli #${helicopter.heliIndex} - Group #${group.groupIndex} (H${helicopter.heliIndex}G${group.groupIndex})`, 10, yPos);
        yPos += 5;

        // Draw table headers
        yPos = drawHeaders(doc, yPos);
        yPos += 1;
      }

      // Client details
      group.clients.forEach(client => {
        doc.setFontSize(7);

        // Calculate the row height needed based on text wrapping
        let maxRowHeight = 4; // Minimum row height

        // First pass: calculate required height for this row
        columns.forEach(col => {
          let cellText = '';
          if (col.key === 'lastName') {
            cellText = client.lastName || 'N/A';
          } else if (col.key === 'firstName') {
            cellText = client.firstName || 'N/A';
          } else if (col.key === 'dietaryRestrictions') {
            cellText = client.dietaryRestrictions ? 'Yes' : 'No';
          } else if (col.key === 'cannotEat') {
            cellText = client.cannotEat || 'N/A';
          } else if (col.key === 'severity') {
            cellText = client.severity || 'N/A';
          }

          const lines = wrapText(doc, cellText, col.width);
          const requiredHeight = Math.max(4, lines.length * 3 + 1.5);
          maxRowHeight = Math.max(maxRowHeight, requiredHeight);
        });

        // Check if we need a new page
        if (yPos + maxRowHeight > 180) {
          doc.addPage('landscape');
          yPos = drawPageHeader(doc, helicopter, group, formattedDate);
          yPos = drawHeaders(doc, yPos);
          yPos += 2;
        }

        // Draw cell borders and content
        let x = 10;
        columns.forEach(col => {
          // Draw cell border
          doc.setDrawColor(200, 200, 200);
          doc.rect(x, yPos, col.width, maxRowHeight);

          // Get cell content and set appropriate color
          let cellText = '';
          let textColor = blackColor;

          if (col.key === 'lastName') {
            cellText = client.lastName || 'N/A';
            textColor = blueColor;
          } else if (col.key === 'firstName') {
            cellText = client.firstName || 'N/A';
            textColor = blueColor;
          } else if (col.key === 'dietaryRestrictions') {
            cellText = client.dietaryRestrictions ? 'Yes' : 'No';
            textColor = client.dietaryRestrictions ? redColor : blackColor;
          } else if (col.key === 'cannotEat') {
            cellText = client.cannotEat || 'N/A';
            textColor = blackColor;
          } else if (col.key === 'severity') {
            cellText = client.severity || 'N/A';
            textColor = blackColor;
          }

          // Set text color
          doc.setTextColor(textColor);

          // Draw cell content
          drawCellText(doc, cellText, x, yPos, col.width, maxRowHeight);

          x += col.width;
        });

        // Reset text color
        doc.setTextColor(blackColor);
        yPos += maxRowHeight;
      });

      // Add spacing between groups (more space to prevent overlap)
      yPos += 15;
    });

    // Calculate and display total lunches
    const totalGuestLunches = helicopter.groups.reduce((acc, group) => acc + group.clients.length, 0);
    
    // Count both primary and additional guides for lunch tallies
    const totalGuideLunches = helicopter.groups.reduce((acc, group) => {
      // Count primary guide if present
      let guideCount = group.guide && group.guide !== 'N/A' ? 1 : 0;
      // Add additional guide if present
      if (group.guideAdditional && group.guideAdditional !== 'N/A') {
        guideCount += 1;
      }
      
      return acc + guideCount;
    }, 0);

    console.log(totalGuideLunches);
    
    const totalPilotLunches = 1;
    const totalLunches = totalGuestLunches + totalGuideLunches + totalPilotLunches;

    // Check if we need space for footer (about 15 units)
    if (yPos + 15 > 180) {
      doc.addPage('landscape');
      yPos = 10;
    }
    yPos += 5; // Space before footer
    doc.setFontSize(12);
    doc.setTextColor(blackColor); // Reset text color to black for footer
    const footerText = `Heli #${helicopter.heliIndex} (Guest Lunches: ${totalGuestLunches}) + (1 Pilot Lunch) + (${totalGuideLunches} Guide Lunches) = Heli #${helicopter.heliIndex} (Total Lunches: ${totalLunches})`;
    const footerParts = footerText.split(`Heli #${helicopter.heliIndex} (Total Lunches: `);
    doc.text(footerParts[0], 10, yPos);
    doc.setTextColor(redColor); // Set text color to red for total lunches
    doc.text(`Heli #${helicopter.heliIndex} (Total Lunches: ${totalLunches})`, 10 + doc.getTextWidth(footerParts[0]), yPos);

    yPos += 10; // Space after each helicopter's total

    //New page after each heli
    //doc.addPage();
    //yPos = 20;
  });

  
  doc.save(`daily-lunch-report-${formattedDate}.pdf`);
}

// Removed splitTextToLines function - now using wrapText function instead